import { APP_NON_NGROK_DOMAIN } from "@/lib/constants/constants";

export const CONSTANTS = {
  LOGIN_LINK: `${APP_NON_NGROK_DOMAIN}/sign-in`,
  SIGNUP_LINK: `${APP_NON_NGROK_DOMAIN}/sign-up`,
  // CALCOM_NAMESPACE: "chat-with-manu-demo",
  // CALCOM_BRAND_COLOR: "#000000",
  // CALCOM_HIDE_EVENT_TYPE_DETAILS: false,
  // CALCOM_LAYOUT: "month_view",
  // CALCOM_LINK: "manu-arora-vesr9s/chat-with-manu-demo",
};

export const BRAND_VOICE_GENERATOR_LINK =
  // "https://autos.seodranker.com/webhook-test/1cc1f991-2006-47c1-8789-8f8d9b742c96";
  "https://autos.seodranker.com/webhook/1cc1f991-2006-47c1-8789-8f8d9b742c96";

export const BACKGROUND_INFO_AGENT_V2_WEBHOOK_URL =
  // "https://autos.seodranker.com/webhook-test/2b202029-9d16-4bf7-961b-0d237144a650";
  "https://autos.seodranker.com/webhook/2b202029-9d16-4bf7-961b-0d237144a650";
